/** Copia texto al portapapeles con dos intentos.
 *
 *  El primero es la API moderna (`navigator.clipboard.writeText`), que
 *  en teoría es la correcta —pero en la práctica falla callada en
 *  varios contextos reales: el navegador del teléfono sin la pestaña
 *  enfocada, ciertos WebView de Android donde corre la PWA instalada,
 *  o cuando el sitio no tiene el permiso de portapapeles concedido.
 *  Cuando eso pasa, se cae al método viejo (una caja de texto oculta +
 *  `execCommand('copy')`), que es menos elegante pero funciona en
 *  bastantes más navegadores porque no depende del mismo permiso.
 *
 *  Devuelve true solo si alguno de los dos intentos realmente copió
 *  algo —así el botón que llama a esto sabe si avisar "copiado" o
 *  "no se pudo copiar" de verdad, en vez de asumirlo. */
export async function copiarTexto(texto: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(texto)
      return true
    } catch {
      // Sigue al método de respaldo de abajo.
    }
  }

  try {
    const area = document.createElement('textarea')
    area.value = texto
    // Fuera de la pantalla pero seleccionable: en iOS Safari, un
    // elemento con display:none o tamaño cero no se puede seleccionar,
    // y sin selección execCommand('copy') no tiene qué copiar.
    area.style.position = 'fixed'
    area.style.top = '0'
    area.style.left = '0'
    area.style.width = '2px'
    area.style.height = '2px'
    area.style.opacity = '0'
    document.body.appendChild(area)
    area.focus()
    area.select()
    area.setSelectionRange(0, texto.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(area)
    return ok
  } catch {
    return false
  }
}
